import React, {Component} from 'react';
import CardWidget from "../card-widget/CardWidget";
import {RouteConstants} from "../route/services/RouteConstants";
import CardWidgetContent from "../card-widget/CardWidgetContent";

class ForgotUserNameSentConfirmation extends Component {

  goToLoginScreen = () => {
    this.props.history.push(RouteConstants.LOGIN);
  };

  getForgotUserNameSentContent = () => {
    return (
        <CardWidgetContent contentText="forgot_username.sent_content"/>
    )
  };

  render() {
    return (
        <CardWidget
            getCardContent={this.getForgotUserNameSentContent}
            submitButtonAction={this.goToLoginScreen}
            submitButtonText="forgot_username.sent_button_content"
        />
    )
  }
}

export default ForgotUserNameSentConfirmation;